export default "__VITE_ASSET__Cd6FLMpl__"